import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { concat, distinctUntilChanged, filter, map, Observable, of, shareReplay } from 'rxjs';

export type Workspace = 'dashboard' | 'collaboration';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  private readonly router = inject(Router);

  private readonly currentRoute$: Observable<string> = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    map((e) => e.urlAfterRedirects)
  );

  readonly workspace$: Observable<Workspace> = concat(of(this.getCurrentRoute()), this.currentRoute$).pipe(
    distinctUntilChanged(),
    map((route) => (route.includes('/collaboration') ? 'collaboration' : 'dashboard')),
    shareReplay(1)
  );

  readonly workspace = toSignal<Workspace>(this.workspace$, {
    requireSync: true,
  });

  private getCurrentRoute(): string {
    const url = new URL(window.location.href);
    return url.pathname;
  }
}
